import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import profileStyles from "../../styles/pages/profile/ProfilePage.module.css";
import styles from "../../styles/components/profile/NotificationsPanel.module.css";

const NotificationsPanelSkeleton = () => {
  return (
    <div className={profileStyles.contentSection}>
      <div className={styles.panel}>
        <div className={profileStyles.sectionHeader}>
          <div>
            <Skeleton height={32} width={220} style={{ marginBottom: 8 }} />
            <Skeleton height={16} width={160} />
          </div>
          <div className={styles.headerActions}>
            <Skeleton height={36} width={100} borderRadius={6} />
            <Skeleton height={36} width={120} borderRadius={6} />
            <Skeleton height={36} width={100} borderRadius={6} />
          </div>
        </div>

        <div className={styles.filterPills}>
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} height={32} width={90} borderRadius={6} />
          ))}
        </div>

        <ul className={styles.list}>
          {[1, 2, 3, 4, 5].map((i) => (
            <li key={i} className={styles.item}>
              <div className={styles.itemContent}>
                <Skeleton circle height={40} width={40} />
                <div className={styles.itemMain}>
                  <Skeleton height={18} width="65%" style={{ marginBottom: 8 }} />
                  <Skeleton height={14} width="90%" count={2} />
                  <Skeleton height={12} width={100} style={{ marginTop: 8 }} />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NotificationsPanelSkeleton;
